<template>
  <div>
    <div class="channelBL" id="clnlFun">
      <a class="chnlsF nodeB " href="/company_introductions"  :class="{'open curChnl': isChooseCompanyIntroductions}">{{$t('company_introductions')}}</a>
      <ul class="chnlsS">
      </ul>
      <ul class="chnlsS">

      </ul>
      <ul class="chnlsS">

      </ul>
      <a class="chnlsF nodeB" href="/organization" :class="{'open curChnl': isChooseOrganization}">{{$t('company_organization')}}</a>
      <ul class="chnlsS">

      </ul>
      <a class="chnlsF nodeB" href="/company_culture" :class="{'open curChnl': isChooseCompanyCulture}">{{$t('company_culture')}}</a>
      <ul class="chnlsS">

      </ul>
      <a class="chnlsF nodeB" href="/contact_us" :class="{'open curChnl': isChooseContactUs}">{{$t('contact_us')}}</a>
      <ul class="chnlsS">

      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CompanyIntroductionsLeftNav',
    data(){
      return{
        isChooseCompanyIntroductions: this.$route.name === 'CompanyIntroductions',
        isChooseOrganization: this.$route.name === 'Organization',
        isChooseCompanyCulture: this.$route.name === 'CompanyCulture',
        isChooseCompanySystem: this.$route.name === 'CompanySystem',
        isChooseContactUs: this.$route.name === 'ContactUs',
        isChoosePersonalBusiness: this.$route.name === 'PersonalBusiness',
        isChooseAgencyBusiness: this.$route.name === 'AgencyBusiness'
      }
    }
  }
</script>
<style>
    .channelBL{
        width: 210px;
    }
</style>